import { ErrorMessage, Form, Formik } from "formik";
import "./itemList.style.css";
import React, {
  useCallback,
  useContext,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import { FaCamera, FaNutritionix, FaSearch } from "react-icons/fa";
import { FiInfo } from "react-icons/fi";
import { IoAddCircleOutline } from "react-icons/io5";
import { TbPoint } from "react-icons/tb";
import BreadCrumb from "../../components/BreadCrumb";
import Button, { SecondaryButton } from "../../components/Button";
import Dropdown from "../../components/Dropdown";
import { FormField } from "../../components/FormField";
import SidebarField from "../../components/Sidebar/SidebarField";
import SidebarRight from "../../components/Sidebar/SidebarRight";
import TextInput from "../../components/TextInput";
import ToggleField from "../../components/ToggleField";
import ReactQuill from "react-quill";
import * as Yup from "yup";
import PaginatorCom from "../../components/Paginator/PaginatorCom";

import {
  CategoryApi,
  PackageApi,
  productApi,
  productImageApi,
  ProductmodifierApi,
  productVariantApi,
  SubCategoryApi,
  TaxRegimeApi,
  UnitApi,
} from "../../apis/ProductListing.apis";
import LoadingContext from "../../components/loader/index";
import ImagePreview from "../../components/ImagePreview";
import { MdDeleteOutline } from "react-icons/md";
import { toast } from "react-toastify";
import DeleteFieldModal from "../../components/DeleteFieldModal";
import DeltaCard from "../../components/DeltaCard";
import { compressImage } from "../../custom/compressImage";
import { LazyLoadImage } from "react-lazy-load-image-component";
import masterApi from "../../apis/master.api";
import LoaderContext from "../../components/loader/index";
import { useFetchAll } from "../../custom/FetchApiHook";
import FormPreview from "../../components/DynamicFields/FormPreview";
import { Calendar } from "primereact/calendar";
import TaxData from "./TaxData";
import { Divider } from "primereact/divider";

const ItemListCashcrop = () => {
  const debounceTimeout = useRef(null);
  const quillEmptyValue = "<p><br></p>";
  const { handleLoading } = useContext(LoadingContext);

  const [addItemVisible, setAddItemVisible] = useState(false);
  const [isClearButton, setIsClearButton] = useState(false);
  const [editVisible, setEditVisible] = useState(false);
  const [step, setStep] = useState(0);
  const [searchQuery, setSearchQuery] = useState("");
  const [selectedSubCategoryId, setSelectedSubCategoryId] = useState("");
  const [subCategory, setSubCategory] = useState([]);
  const [packageData, setPackageData] = useState([]);
  const [allProducts, setAllProducts] = useState([]);
  const [Taxes, setTaxes] = useState([]);
  const [deliveryType, setDeliveryType] = useState(null);
  const [productDetailsWithTax, setProductDetailsWithTax] = useState([]);
  const [categoryId, setCategoryId] = useState(null);
  const [unitMasterData, setUnitMasterData] = useState(null);
  const [dynamicFields, setDynamicFields] = useState([]);
  const [nutritionalFields, setNutritionalFields] = useState([]);
  const [calculationError, setCalculationError] = useState(null);

  // Country (Origin) dropdown state
  const countryData = useFetchAll(() => masterApi.getAllCountry());
  const countryOptions = countryData.value?.data
    ? countryData.value.data.map((c) => ({ label: c.name, value: c._id }))
    : [];

  const [productPagination, setProductPagination] = useState({
    page: 1,
    limit: 8,
    sortOrder: "desc",
    filter: {},
    totalPages: 1,
    totalCount: 5,
  });
  const [editData, setEditData] = useState("");
  const [editProduct, setEditProduct] = useState("");
  const [imagesList, setImagesList] = useState([]);
  const [deleteModal, setDeleteModal] = useState(false);
  const [deleteModalData, setDeleteModalData] = useState({
    itemName: null,
    itemData: null,
  });

  const [isShowDescriptionid, setIsShowDescriptionid] = useState(null);

  const initialProductValues = {
    primary_image: editProduct?.primary_image || null,
    name: editProduct?.name || null,
    // serial_number: editProduct?.serial_number || null,
    mrp_price: editProduct?.mrp_price?.$numberDecimal || 0.0,
    sales_price: editProduct?.sales_price?.$numberDecimal || 0.0,
    quality_grade: editProduct?.quality_grade || null,
    package_type: editProduct?.package_type || "",
    stock: editProduct?.stock || 0,
    // price_per_unit: editProduct?.price_per_unit?.$numberDecimal || 0,
    unit: editProduct?.unit || "",
    harvest_date: editProduct?.harvest_date
      ? new Date(editProduct.harvest_date)
      : null,
    tax: editProduct?.tax?._id || null,
    sub_category: editProduct?.subCategory?._id || null,
    additional_info: editProduct?.additional_info || null,
    description: editProduct?.description || null,
    specification: editProduct?.specification || null,
    cancellation_policy: editProduct?.cancellation_policy || null,
    replacement_policy: editProduct?.replacement_policy || null,
    return_policy: editProduct?.return_policy || null,
    Policy_Validity_Days: editProduct?.Policy_Validity_Days || 0,
    is_visible: editProduct?.is_visible || true,
    // sequence: editProduct?.sequence || null,
    dynamicFields: editProduct?.dynamicFields || {},
    nutritionalFields: editProduct?.nutritionalFields || {},
    origin: editProduct?.origin?._id || null,
    processing: editProduct?.processing || null,
    certification: editProduct?.certification || null,
    packaging: editProduct?.packaging || null,
  };
  const MAX_FILE_SIZE = 5 * 1024 * 1024; // 5MB
  const SUPPORTED_FORMATS = [
    "image/jpg",
    "image/jpeg",
    "image/png",
    "image/webp",
  ];

  const validationSchema = Yup.object().shape({
    /* Step 0 – Item Info */

    primary_image: Yup.mixed()
      .required("Primary image is required")
      .test("fileSize", "Image size must be less than 5MB", (value) => {
        if (!value) return false;

        // Edit mode (image URL string)
        if (typeof value === "string") return true;

        return value.size <= MAX_FILE_SIZE;
      })
      .test(
        "fileFormat",
        "Unsupported file format. Only JPG, JPEG, PNG, WEBP allowed",
        (value) => {
          if (!value) return false;

          // Edit mode (image URL string)
          if (typeof value === "string") return true;

          return SUPPORTED_FORMATS.includes(value.type);
        },
      ),

    sub_category: Yup.string().required("Sub category is required").nullable(),

    origin: Yup.string().required("Origin country is required").nullable(),

    name: Yup.string()
      .trim()
      .min(2, "Item name must be at least 2 characters")
      .max(100, "Item name cannot exceed 100 characters")
      .required("Item name is required"),

    tax: Yup.string().required("Tax is required").nullable(),

    mrp_price: Yup.number()
      .typeError("MRP price must be a number")
      .positive("MRP price must be greater than 0")
      .required("MRP price is required"),

    sales_price: Yup.number()
      .typeError("Sales price must be a number")
      .positive("Sales price must be greater than 0")
      .max(Yup.ref("mrp_price"), "Sales price cannot be greater than MRP price")
      .required("Sales price is required"),

    stock: Yup.number()
      .typeError("Stock must be a number")
      .integer("Stock must be an integer")
      .min(0, "Stock cannot be negative")
      .required("Available quantity is required"),

    unit: Yup.string().required("Unit is required").nullable(),

    quality_grade: Yup.string().required("Quality grade is required"),

    package_type: Yup.string()
      .required("Package type is required")
      .nullable(),

    harvest_date: Yup.date().nullable().required("Harvest date is required"),

    description: Yup.string()
      .test(
        "description-required",
        "Description is required",
        (value) => {
          if (!value || value === quillEmptyValue) {
            return false;
          }

          const plainText = value
            .replace(/<[^>]*>/g, "")
            .replace(/&nbsp;/g, " ")
            .trim();

          return Boolean(plainText);
        },
      )
      .max(1000, "Description cannot exceed 1000 characters"),

    additional_info: Yup.string().max(
      1000,
      "Additional information cannot exceed 1000 characters",
    ),

    processing: Yup.string().max(
      1000,
      "Processing details cannot exceed 1000 characters",
    ),

    certification: Yup.string().max(
      1000,
      "Certification details cannot exceed 1000 characters",
    ),

    packaging: Yup.string().max(
      1000,
      "Packaging details cannot exceed 1000 characters",
    ),

    specification: Yup.string()
      .test(
        "specification-required",
        "Specification is required",
        (value) => {
          if (!value || value === quillEmptyValue) {
            return false;
          }

          const plainText = value
            .replace(/<[^>]*>/g, "")
            .replace(/&nbsp;/g, " ")
            .trim();

          return Boolean(plainText);
        },
      )
      .max(1000, "Specification cannot exceed 1000 characters"),

    cancellation_policy: Yup.string()
      .test(
        "cancellation-policy-required",
        "Cancellation policy is required",
        (value) => {
          if (!value || value === quillEmptyValue) {
            return false;
          }

          const plainText = value
            .replace(/<[^>]*>/g, "")
            .replace(/&nbsp;/g, " ")
            .trim();

          return Boolean(plainText);
        },
      )
      .max(1000, "Cancellation policy cannot exceed 1000 characters"),

    replacement_policy: Yup.string()
      .test(
        "replacement-policy-required",
        "Replacement policy is required",
        (value) => {
          if (!value || value === quillEmptyValue) {
            return false;
          }

          const plainText = value
            .replace(/<[^>]*>/g, "")
            .replace(/&nbsp;/g, " ")
            .trim();

          return Boolean(plainText);
        },
      )
      .max(1000, "Replacement policy cannot exceed 1000 characters"),

    return_policy: Yup.string()
      .test(
        "return-policy-required",
        "Return policy is required",
        (value) => {
          if (!value || value === quillEmptyValue) {
            return false;
          }

          const plainText = value
            .replace(/<[^>]*>/g, "")
            .replace(/&nbsp;/g, " ")
            .trim();

          return Boolean(plainText);
        },
      )
      .max(1000, "Return policy cannot exceed 1000 characters"),

    Policy_Validity_Days: Yup.number()
      .typeError("Policy validity days must be a number")
      .integer("Policy validity days must be an integer")
      .min(0, "Policy validity days cannot be negative")
      .max(60, "Policy validity days cannot more then 60 days")
      .required("Policy validity days are required"),

    is_visible: Yup.boolean(),

    /* Step 1 – Dynamic Fields */
    dynamicFields: Yup.object().nullable(),

    nutritionalFields: Yup.object().nullable(),
  });

  const buildTouchedState = (value) => {
    if (Array.isArray(value)) {
      return value.map((item) => buildTouchedState(item));
    }

    if (value && typeof value === "object") {
      return Object.keys(value).reduce((acc, key) => {
        acc[key] = buildTouchedState(value[key]);
        return acc;
      }, {});
    }

    return true;
  };

  const getFirstErrorMessage = (value) => {
    if (!value) {
      return null;
    }

    if (typeof value === "string") {
      return value;
    }

    if (Array.isArray(value)) {
      for (const item of value) {
        const message = getFirstErrorMessage(item);
        if (message) {
          return message;
        }
      }
      return null;
    }

    if (typeof value === "object") {
      for (const key of Object.keys(value)) {
        const message = getFirstErrorMessage(value[key]);
        if (message) {
          return message;
        }
      }
    }

    return null;
  };

  const pickStepErrors = (errors, currentStep) => {
    if (!errors || typeof errors !== "object") {
      return {};
    }

    if (currentStep === 0) {
      const stepZeroFields = [
        "primary_image",
        "sub_category",
        "origin",
        "name",
        "tax",
        "mrp_price",
        "sales_price",
        "stock",
        "unit",
        "quality_grade",
        "package_type",
        "harvest_date",
        "description",
        "specification",
        "cancellation_policy",
        "replacement_policy",
        "return_policy",
        "Policy_Validity_Days",
        "dynamicFields",
      ];

      return stepZeroFields.reduce((acc, key) => {
        if (errors[key]) {
          acc[key] = errors[key];
        }
        return acc;
      }, {});
    }

    if (currentStep === 1) {
      return errors.nutritionalFields ? { nutritionalFields: errors.nutritionalFields } : {};
    }

    return {};
  };

  const taxRegimeData = useFetchAll(() => TaxRegimeApi.getAllRegimeApi());
  const taxOptions = taxRegimeData.value?.data
    ? taxRegimeData.value?.data?.map((d) => {
        d.label = d.name;
        d.value = d._id;
        return d;
      })
    : [{}];

  const handleDeleteClose = () => {
    setDeleteModal(false);
  };

  const openDeleteModal = (name, value) => {
    setDeleteModalData((prev) => {
      return {
        itemName: name,
        itemData: value,
      };
    });
    setDeleteModal(true);
  };

  const handleDelete = async () => {
    handleLoading(true);

    try {
      let res;

      if (deleteModalData.itemName === "product") {
        res = await productApi.deleteProduct(deleteModalData.itemData._id);
        toast.success(`${res.data.message}`);
        getAllProducts();
      }

      if (deleteModalData.itemName === "variant") {
        res = await productVariantApi.deleteProductVariant(
          deleteModalData.itemData._id,
        );
        toast.success(`${res.data.message}`);
        getAllProductVariants();
      }
      if (deleteModalData.itemName === "modifier_category") {
        res = await ProductmodifierApi.deleteModifierMapping(
          deleteModalData.itemData._id,
        );
        toast.success(`${res.data.message}`);
        getAllProductModifier();
      }

      if (deleteModalData.itemName === "product_images") {
        res = await productImageApi.deleteProductImage(
          deleteModalData.itemData._id,
        );
        toast.success(`${res.data.message}`);
        getAllProductImages();
      }

      if (deleteModalData.itemName === "subcategory") {
        res = await SubCategoryApi.deleteSubCategory(
          deleteModalData.itemData._id,
        );
        toast.success(`${res.data.message}`);
        getAllSubcategory();
      }
    } catch (err) {
      console.log(err);
    } finally {
      setDeleteModalData({ itemName: null, itemData: null });
      handleLoading(false);
      handleDeleteClose();
    }
  };

  const handleOpen = () => {
    setEditVisible(true);
  };

  const handleClose = () => {
    setEditData("");
    setEditProduct("");
    setEditVisible(false);
  };

  const handleCloseItem = () => {
    setEditProduct("");
    setImagesList([]);
    setAddItemVisible(false);
    // setDeliveryType(null);
    setProductDetailsWithTax([]);
    // setTaxes([]);
    setStep(0);
  };

  const TaxCalculation = (data) => {
    const productDetailsWithTaxCopy = data ? data : [...productDetailsWithTax];

    const deliveryTypeCopy = deliveryType ? { ...deliveryType } : {};
    const TaxesCopy = Taxes.length ? [...Taxes] : editProduct?.tax?.taxes || [];

    if (productDetailsWithTaxCopy?.length && TaxesCopy?.length) {
      productDetailsWithTaxCopy.forEach((item, index) => {
        if (item.sales_price) {
          const salesPrice = parseFloat(item.sales_price) || 0;

          const standardTax = [];
          const standardTotalTaxAmount = TaxesCopy.filter(
            (t) => t.taxType !== "TAX",
          ).reduce((sum, t) => {
            const rate = parseFloat(t?.rate?.$numberDecimal) || 0;
            const taxAmount = (rate * salesPrice) / 100;
            standardTax.push({
              name: t.name,
              rate: rate,
              taxType: "REBASE TAX",
              taxAmount: taxAmount.toFixed(2),
            });

            return sum + taxAmount;
          }, 0);

          // Ensure all delivery type values are numbers
          const additionalFee =
            parseFloat(deliveryTypeCopy?.additionalFee) || 0;
          const closingFee = parseFloat(deliveryTypeCopy?.closingFeeRate) || 0;
          const referralFeeRate =
            parseFloat(deliveryTypeCopy?.referralFeeRate) || 0;

          const rebase = parseFloat(salesPrice + standardTotalTaxAmount) || 0;
          const referralFee = (rebase * referralFeeRate) / 100;
          const taxableAmount =
            rebase + referralFee + closingFee + additionalFee;

          // VAT Calculation
          const Vat = TaxesCopy.filter((t) => t.taxType === "TAX").map((d) => {
            const vatRate = parseFloat(d?.rate?.$numberDecimal) || 0;
            const taxAmount = (taxableAmount * vatRate) / 100 || 0;

            return {
              name: d.name,
              rate: vatRate,
              taxType: "REBASE TAX",
              taxAmount: taxAmount.toFixed(2),
            };
          });

          const grandTotal = taxableAmount + parseFloat(Vat[0]?.taxAmount || 0);

          const taxData = {
            standardTax: standardTax,
            standardTotalTaxAmount: standardTotalTaxAmount.toFixed(2),
            referralFee: {
              percentage: referralFeeRate,
              amount: referralFee.toFixed(2),
            },
            closingFee: closingFee.toFixed(2),
            additionalFee: additionalFee.toFixed(2),
            rebase: rebase.toFixed(2),
            taxableAmount: taxableAmount.toFixed(2),
            vat: Vat,
            grandTotal: grandTotal.toFixed(2),
          };

          item.taxData = taxData;
          productDetailsWithTaxCopy[index] = item;
        }
      });

      setProductDetailsWithTax(productDetailsWithTaxCopy);
      return productDetailsWithTaxCopy;
    }
  };

  const handleProductClick = (value) => {
    console.log("jjkhjkhjk");
    setIsShowDescriptionid(
      isShowDescriptionid === value._id ? null : value._id,
    );
    handleCloseItem();

    setTimeout(() => {
      if (value !== "") {
        const product_details = [
          { mrp_price: value.mrp_price?.$numberDecimal },
          { sales_price: value.sales_price?.$numberDecimal },
        ];
        setProductDetailsWithTax(product_details);
        setTaxes(value?.tax?.taxes);
        const subCategoryData = subCategory.filter(
          (s) => s._id === value?.subCategory?._id,
        );
        getDeliveryTypeById(subCategoryData[0]?.category?.delivery_calculation);
        TaxCalculation();
      }
      setEditProduct(value);
      console.log("value is", value);
      setAddItemVisible(true);
      setStep(0);
    }, 100);
  };

 const handleNext = async (values, formikHelpers) => {
  const { setTouched, validateForm } = formikHelpers;

  // ─── STEP 1: Nutritional fields only ────────────────────────────────────────
  if (step === 1) {
    handleLoading(true);
    try {
      const id = editProduct?.product?._id
        ? editProduct?.product?._id
        : editProduct?._id;

      if (id) {
        // Only send nutritional + dynamic fields — no prices, no stock
        const nutritionalPayload = {
          nutritionalFields: values.nutritionalFields,
          dynamicFields: values.dynamicFields,
        };
        const resProduct = await productApi.updateProduct(nutritionalPayload, id);
        setEditProduct(resProduct?.data?.data);
      }

      handleLoading(false);
      setStep((prevStep) => Math.min(prevStep + 1, 3));
    } catch (error) {
      handleLoading(false);
      toast.error(
        error?.response?.data?.message || error?.message || "Failed to save nutritional info",
      );
    }
    return; // ← skip ALL validation for step 1
  }

  // ─── STEP 2: Images — just advance ──────────────────────────────────────────
  if (step === 2) {
    handleCloseItem();
    getAllProducts();
    return;
  }

  // ─── STEP 0: Full validation + create/update ─────────────────────────────────
  const primary__image = document.getElementById("primary_image");
  const item_name = document.getElementById("item_name");
  const mrp_price = document.getElementById("mrp_price");
  const sales_price = document.getElementById("sales_price");
  const sub_category = document.getElementById("sub_category");
  const origin = document.getElementById("origin");
  const tax = document.getElementById("tax");
  const unit = document.getElementById("unit");
  const package_type = document.getElementById("package_type");
  const harvest_date = document.getElementById("harvest_date");
  const description = document.getElementById("description");
  const specification = document.getElementById("specification");
  const cancellation_policy = document.getElementById("cancellation_policy");
  const replacement_policy = document.getElementById("replacement_policy");
  const return_policy = document.getElementById("return_policy");

  // Remove blink highlights after 3s
  setTimeout(() => {
    [
      primary__image, item_name, mrp_price, sales_price, sub_category,
      origin, tax, unit, package_type, harvest_date, description,
      specification, cancellation_policy, replacement_policy, return_policy,
    ].forEach((el) => el?.classList.remove("blink-shadow"));
  }, 3000);

  const validateProductDetail = () => {
    const mrp = Number(productDetailsWithTax?.[0]?.mrp_price);
    const grandTotal = Number(productDetailsWithTax?.[1]?.taxData?.grandTotal);
    if (grandTotal > mrp) {
      toast("Grand Total should not exceed MRP Price!");
      sales_price?.classList.add("blink-shadow");
      return true;
    }
    return false;
  };

  const allErrors = await validateForm();
  const errors = pickStepErrors(allErrors, 0); // always validate step 0 fields

  if (Object.keys(errors).length) {
    setTouched(buildTouchedState(errors), true);
    toast.error(
      getFirstErrorMessage(errors) ||
        "Please fix the highlighted errors before continuing.",
    );

    if (errors.primary_image && primary__image) primary__image.classList.add("blink-shadow");
    if (errors.name && item_name) item_name.classList.add("blink-shadow");
    if (errors.sub_category && sub_category) sub_category.classList.add("blink-shadow");
    if (errors.origin && origin) origin.classList.add("blink-shadow");
    if (errors.tax && tax) tax.classList.add("blink-shadow");
    if (errors.mrp_price && mrp_price) mrp_price.classList.add("blink-shadow");
    if (errors.sales_price && sales_price) sales_price.classList.add("blink-shadow");
    if (errors.unit && unit) unit.classList.add("blink-shadow");
    if (errors.package_type && package_type) package_type.classList.add("blink-shadow");
    if (errors.harvest_date && harvest_date) harvest_date.classList.add("blink-shadow");
    if (errors.description && description) description.classList.add("blink-shadow");
    if (errors.specification && specification) specification.classList.add("blink-shadow");
    if (errors.cancellation_policy && cancellation_policy) cancellation_policy.classList.add("blink-shadow");
    if (errors.replacement_policy && replacement_policy) replacement_policy.classList.add("blink-shadow");
    if (errors.return_policy && return_policy) return_policy.classList.add("blink-shadow");
    return;
  }

  if (validateProductDetail()) return;

  handleLoading(true);
  try {
    values.taxData = productDetailsWithTax[1].taxData;
    const id = editProduct?.product?._id
      ? editProduct?.product?._id
      : editProduct?._id;

    const resProduct = id
      ? await productApi.updateProduct(values, id)
      : await productApi.createProduct(values);
    setEditProduct(resProduct?.data?.data);
  } catch (error) {
    if (error?.errors && error?.errors?.mrp_price) {
      setCalculationError(error?.errors);
    }
    handleLoading(false);
    toast.error(
      error?.response?.data?.message || error?.message || "Failed to save item",
    );
    return;
  }

  handleLoading(false);
  setStep((prevStep) => Math.min(prevStep + 1, 3));
};

  const handleBack = async () => {
    setStep((prevStep) => Math.max(prevStep - 1, 0));
  };

  const handleAddMultipleImages = async (e, id = false) => {
    const images = e.target.files;
    const formData = new FormData();

    for (let i = 0; i < images.length; i++) {
      formData.append("image", images[i]);
    }
    const ProductId = editProduct?.product?._id
      ? editProduct?.product?._id
      : editProduct?._id;

    !id && formData.append("product", ProductId);

    if (images.length) {
      handleLoading(true);
      try {
        const res = id
          ? await productImageApi.updateProductImage(formData, id)
          : await productImageApi.createProductImages(formData);
        getAllProductImages();
      } catch (error) {
        console.error("Error uploading images:", error);
        toast.error(error.message);
      }
      handleLoading(false);
    }
  };

  const handleFileUpload = (e, setFieldValue) => {
    const f = e.target.files[0];

    compressImage(f, (ci) => {
      setFieldValue("primary_image", ci);
    });
  };

  const handleSubmitSubcategory = async (values, resetForm) => {
    try {
      const createRes = editData
        ? await SubCategoryApi.updateSubCategory(values, editData._id)
        : await SubCategoryApi.createSubCategory(values);
      toast.success(
        editData._id ? "Subcategory updated" : "Subcategory created",
      );
      if (!editData) {
        toast.info(
          "Subcategory is pending approval. It will be visible once approved by an admin.",
        );
      }
      getAllSubcategory();
    } catch (err) {
      toast.error(err?.message);
    } finally {
      resetForm();
      setEditData("");
      handleClose();
    }
  };

  const handleSubmit = async (values, { resetForm }) => {
    handleLoading(true);
    if (step === 2) {
    } else {
      handleSubmitSubcategory(values, resetForm);
    }
    handleLoading(false);
  };

 const handleProductPagination = (data) => {
  // ✅ CLEAR FILTER CASE
  if (data.clear === true) {
    setProductPagination({
      page: 1,
      limit: 8,
      sortOrder: "desc",
      filter: {}, // 💥 completely reset
    });
    return;
  }

  // ✅ NORMAL FILTER / PAGINATION CASE
  setProductPagination((prev) => ({
    page: data.page ?? prev.page,
    limit: data.limit ?? prev.limit,
    sortOrder: data.sortOrder ?? prev.sortOrder,
    filter: data.filter ?? prev.filter,
  }));
};


  const getPackageData = async () => {
    handleLoading(true);
    try {
      const res = await PackageApi.getAllPackageMaster();
      const subcategoriesData =
        res.data?.data.length &&
        res.data?.data.map((o, i) => {
          o.value = o._id;
          o.label = o?.packaging_name;
          return o;
        });

      setPackageData(subcategoriesData);
    } catch (err) {
      toast.error(err?.message);
    } finally {
      handleLoading(false);
    }
  };

  const getAllUnitData = async () => {
    handleLoading(true);
    try {
      const res = await UnitApi.getAllUnitMaster();
      const AllUnitData = res.data?.data?.map((o, i) => {
        o.value = o._id;
        o.label = o?.unit;
        return o;
      });
      setUnitMasterData(AllUnitData);
    } catch (err) {
      toast.error(err?.message);
    } finally {
      handleLoading(false);
    }
  };

  const getAllSubcategory = async () => {
    handleLoading(true);
    try {
      const res = await SubCategoryApi.getSubCategory();
      const subcategoriesData =
        res.data?.data.length &&
        res.data?.data.map((o, i) => {
          o.value = o._id;
          o.label = o?.category ? `${o.category.name} > ${o.name}` : o.name;
          return o;
        });
      setCategoryId(editProduct?.subCategory?.category);

      setSubCategory(subcategoriesData);
    } catch (err) {
      toast.error(err?.message);
    } finally {
      handleLoading(false);
    }
  };

  const getAllProducts = async () => {
    handleLoading(true);
    try {
      const res = await productApi.getAllProducts(
        productPagination,
        searchQuery,
      );
      console.log(res.data?.data);
      setAllProducts(res.data?.data);
    } catch (err) {
      toast.error(err?.message);
    } finally {
      handleLoading(false);
    }
  };

  const getProductById = async () => {
    handleLoading(true);
    if (editProduct._id) {
      try {
        const resProduct = await productApi.getProductById(editProduct._id);
        setEditProduct(resProduct.data.data);
      } catch (error) {
        toast.error(error?.message);
      }
    }
    handleLoading(false);
  };

  const getAllProductImages = async () => {
    const productId = editProduct?.product?._id
      ? editProduct?.product?._id
      : editProduct?._id;
    handleLoading(true);
    if (productId) {
      try {
        const resUpload = await productImageApi.getAllProductImages(productId);
        setImagesList(resUpload.data.data);
      } catch (error) {
        toast.error(error?.message);
      }
    }
    handleLoading(false);
  };

  const getAllProductModifier = async () => {
    handleLoading(true);
    try {
      const res = await ProductmodifierApi.getAllProductModifier(
        editProduct._id,
      );
    } catch (error) {
      toast.error(error?.message);
    }

    handleLoading(false);
  };

  const getAllProductVariants = async () => {
    handleLoading(true);
    try {
      const productId = editProduct?.product?._id
        ? editProduct?.product?._id
        : editProduct?._id;
      const res = await productVariantApi.getAllProductVariants(productId);
    } catch (error) {
      toast.error(error?.message);
    }

    handleLoading(false);
  };

  const getAllTax = async () => {
    handleLoading(true);
    try {
      const res = await masterApi.getAllTax();
      let allTaxData = res?.data?.data?.allTaxMaster
        ? res?.data?.data?.allTaxMaster
        : [];
      allTaxData = allTaxData.length
        ? allTaxData.map((t, i) => {
            t.label = `${t.name}@${t.rate.$numberDecimal}%`;
            t.value = t._id;
            return t;
          })
        : [{}];
    } catch (error) {
      console.log(error);
    }

    handleLoading(false);
  };

  const getDeliveryTypeById = async (id) => {
    handleLoading(true);

    try {
      const res = await masterApi.getDeliveryFeeById(id);
      const deliveryFee = {
        additionalFee: res?.data?.data?.additionalFee,
        closingFeeRate: res?.data?.data?.closingFeeRate,
        referralFeeRate: res?.data?.data?.referralFeeRate,
        shippingFeeRate: res?.data?.data?.shippingFeeRate,
        shippingHandlingFeeFixedRate:
          res?.data?.data?.shippingHandlingFeeFixedRate,
      };

      setDeliveryType(deliveryFee);
      // return deliveryFee
    } catch (error) {}

    handleLoading(false);
  };

  const handleSearch = useCallback((s) => {
    setSearchQuery(s);
  }, []);

  const debouncedSearch = useCallback(
    (s) => {
      if (debounceTimeout.current) {
        clearTimeout(debounceTimeout.current);
      }
      debounceTimeout.current = setTimeout(() => {
        handleSearch(s.target.value);
      }, 1500);
    },
    [handleSearch],
  );

  const FilterSubcategoryProdct = (item) => {
  if (item) {
    setSelectedSubCategoryId(item._id);
    setIsClearButton(true);

    handleProductPagination({
      page: 1,
      limit: 8,
      sortOrder: "desc",
      filter: {
        sub_category: item._id,
      },
    });
  } else {
    // ✅ CLEAR FILTER
    setSelectedSubCategoryId(null);
    setIsClearButton(false);

    handleProductPagination({
      clear: true, // 🔥 explicit clear flag
    });
  }
};


  const stepIndex = useMemo(async () => {
    getProductById();
    getAllProducts();
    if (step === 1) {
      getAllProductImages();
    }
    if (step === 2) {
      // getModifierCategory();
      // getAllProductModifier();
      // getAllProductVariants();
    }
  }, [step]);

  const getCategory = async () => {
    handleLoading(true);
    if (categoryId) {
      try {
        const res = await CategoryApi.getSingleCategory(categoryId);

        res?.data?.data?.dynamicFields &&
          res?.data?.data?.dynamicFields?.length &&
          setDynamicFields(res?.data?.data?.dynamicFields);
        res?.data?.data?.nutritionalFields &&
          res?.data?.data?.nutritionalFields?.length &&
          setNutritionalFields(res?.data?.data?.nutritionalFields);
      } catch (error) {}
    }
    handleLoading(false);
  };

  useEffect(() => {
    getCategory();
  }, [categoryId]);

  useEffect(() => {
    getAllSubcategory();
    getAllTax();
    getPackageData();
    getAllUnitData();
  }, [editProduct]);

  useEffect(() => {
    getAllProducts();
  }, [productPagination, searchQuery]);

  useEffect(() => {
    TaxCalculation();
  }, [editProduct, deliveryType, Taxes]);

  return (
    <>
      <div className="flex justify-between">
        <div className="lg:w-9/12 p-10">
          <div className="flex justify-between items-center flex-wrap mb-2">
            <BreadCrumb title="Item" />
            <Button
              text="Add New"
              type="button"
              className="float-end"
              onClick={() => setAddItemVisible(true)}
            />
          </div>
          <div className="mb-5 border-b pb-2 flex items-center justify-between">
            <div className="border border-[--color--1] rounded-full px-3 py-1.5 text-xs bg-transparent w-fit flex justify-between items-center">
              <input
                type="search"
                placeholder="search..."
                // value={searchQuery}
                onChange={debouncedSearch}
                className="bg-transparent outline-none"
              />
              <FaSearch className="text-[--color--1]" />
            </div>
            {/* <SecondaryButton
              onClick={() => FilterSubcategoryProdct()}
              text={"Clear Filter"}
              type={"submit"}
              padding={"py-2 px-3"}
            /> */}
          </div>
          <div className="flex gap-4 flex-wrap">
            {/* {JSON.stringify(allProducts)} */}
            {allProducts?.products &&
              allProducts?.products.map((item) => (
                <DeltaCard
                  isShowDescriptionid={isShowDescriptionid}
                  handleProductClick={handleProductClick}
                  item={item}
                  key={item.id}
                  openProductDeletModal={openDeleteModal}
                />
              ))}
          </div>
          <div className="flex justify-center items-center">
            <PaginatorCom
              paginatorData={{
                page: allProducts?.page ? allProducts?.page : 1,
                rows: allProducts?.limit ? allProducts?.limit : 5,
                totalPages: allProducts?.totalPages
                  ? allProducts?.totalPages
                  : 1,
                totalCount: allProducts?.totalCount
                  ? allProducts?.totalCount
                  : 1,
              }}
              onPaginatorClick={(e) => {
                if (e) {
                  const data = {
                    limit: e.rows,
                    page: +e.page + 1,
                  };
                  handleProductPagination(data);
                }
              }}
            />
          </div>
        </div>
        <SidebarRight>
          <div className="pb-5 border-b border-gray-200/70">
            <div className="flex items-center justify-end mb-3">
              

              <div className="flex items-center gap-3">
                {isClearButton&&<Button
                cssClass="px-3 py-2 bg-red600 hover:bg-red700"
                type="button"
                text="Clear Filter"
                onClick={() => FilterSubcategoryProdct(null)}
              />}
               <Button
                cssClass="px-3 py-2"
                type="button"
                text="Add New"
                onClick={handleOpen}
              />
              </div>
            </div>
              <h1 className="text-xl font-semibold text-gray-900">
                Sub Categories
              </h1>
          </div>

          <div className="w-full flex flex-col mt-2">
            {subCategory?.length > 0 ? (
              subCategory.map((item, index) => {
                // Assuming you store the currently selected subcategory's _id
                const isSelected = selectedSubCategoryId === item._id; // ← you need this state

                return (
                  <div
                    key={item._id || index}
                    onClick={() => FilterSubcategoryProdct(item)}
                    className={`
              flex items-center justify-between 
              py-3 px-3 
              cursor-pointer 
              transition-colors duration-150
              border-b border-gray-100 last:border-b-0
              hover:bg-gray-50
              ${
                isSelected
                  ? "bg-blue-50 border-l-4 border-l-blue-600 font-medium text-blue900"
                  : "text-gray-700"
              }
            `}
                  >
                    <div className="flex items-center gap-3">
                      <TbPoint
                        style={{
                          color: item.is_visible ? "#10b981" : "#ef4444",
                        }}
                        className="text-xl flex-shrink-0"
                      />
                      <span className="truncate">{item.name}</span>
                    </div>

                    {isSelected && (
                      <svg
                        className="w-5 h-5 text-blue600"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth={2.5}
                          d="M5 13l4 4L19 7"
                        />
                      </svg>
                    )}
                  </div>
                );
              })
            ) : (
              <div className="py-6 text-center text-gray500">
                No subcategories found
              </div>
            )}
          </div>
        </SidebarRight>
      </div>

      {addItemVisible && (
        <Formik
          initialValues={initialProductValues}
          validationSchema={validationSchema}
          validate={(values) => {
            const errors = {};
            if (values?.description?.length > 1000) {
              errors.description =
                "Description must be 1000 characters or less.";
            }
            return errors;
          }}
          onSubmit={handleSubmit}
          enableReinitialize
          validateOnBlur
          validateOnChange={false}
        >
          
          {({
            handleChange,
            setFieldValue,
            errors,
            setTouched,
            validateForm,
            touched,
            isSubmitting,
            isValid,
            values,
          }) => (
            <SidebarField
              button1={
                step === 0 ? (
                  ""
                ) : (
                  <Button text="Back" type="button" onClick={handleBack} />
                )
              }
              button2={
                <Button
                  text={step === 2 ? "Submit" : "Next "}
                  type="button"
                  disable={isSubmitting}
                  onClick={() => handleNext(values, { setTouched, validateForm })}
                />
              }
              handleClose={() => handleCloseItem()}
              title={editProduct._id ? "Edit Item " : "Add New Item"}
            >
              <div className="flex items-center mx-10">
                {[
                  "iteminfo",
                  "Nutritions",
                  "images",
                  // "Variants"
                ].map((section, index) => (
                  <React.Fragment key={index}>
                    <div
                      className={`flex flex-col gap-2 items-center w-5 justify-center cursor-pointer`}
                      // onClick={() => handleProductNav(index)}
                      // aria-disabled={
                      //   toggle !== "iteminfo" && section !== toggle
                      // }
                      // disabled={toggle !== "iteminfo" && section !== toggle}
                    >
                      <span
                        className={`p-2 border rounded-full ${
                          index === step
                            ? "border-buttonColor"
                            : "border-slate-300"
                        }`}
                      >
                        {section === "iteminfo" && (
                          <FiInfo
                            className={`${
                              index === step ? "" : "text-slate-300"
                            } text-lg`}
                          />
                        )}
                        {section === "Nutritions" && (
                          <FaNutritionix
                            className={`${
                              index === step ? "" : "text-slate-300"
                            } text-lg`}
                          />
                        )}
                        {section === "images" && (
                          <FaCamera
                            className={`${
                              index === step ? "" : "text-slate-300"
                            } text-lg`}
                          />
                        )}
                        {/* {section === "Variants" && (
                            <FaRegCircleCheck
                              className={`${
                                index === step ? "" : "text-slate-300"
                              } text-lg`}
                            />
                          )} */}
                      </span>
                      <span className="font-semibold">
                        {section.charAt(0).toUpperCase() + section.slice(1)}
                      </span>
                    </div>
                    {index < 2 && <div className="border-t w-full "></div>}
                  </React.Fragment>
                ))}
              </div>
              {/* <div className="flex justify-center">
              {step===1 && imagesList.length? (<MdDeleteOutline className="text-3xl text-red700"/>):""}
              </div> */}
              <Form className="w-full flex gap-4  flex-col bg-transparent py-5 px-3">
                {/* {JSON.stringify(editProduct)} */}
                {step === 0 && (
                  <>
                    {/* primary image */}
                    <div className="flex items-center justify-center">
                      <div>
                        <label
                          htmlFor="primary_image"
                          className="w-60 h-60 shadow-lg border border-gray200 rounded-xl flex flex-col items-center justify-center cursor-pointer transition-all duration-200 hover:shadow-xl hover:border-gren400"
                        >
                        {/* Image Upload Icon */}
                          {!values.primary_image && (
                            <IoAddCircleOutline className="text-6xl text-gray400 mb-2" />
                          )}

                        {/* Hidden Input for File Upload */}
                          <input
                            type="file"
                            id="primary_image"
                            accept="image/*"
                            name="primary_image"
                            onChange={(e) => handleFileUpload(e, setFieldValue)}
                            style={{ display: "none" }}
                            required
                          />

                        {/* Display Placeholder Text if No Image */}
                          {!values.primary_image && (
                            <span className="text-gray600 font-semibold">
                              Add Image
                            </span>
                          )}

                        {/* Display Uploaded Image */}
                          {editProduct?._id &&
                          typeof values.primary_image !== "object" ? (
                            <LazyLoadImage
                              src={values.primary_image}
                              alt="Uploaded"
                              loading="lazy"
                              effect="blur"
                              style={{
                                width: "100%",
                                height: "100%",
                                objectFit: "contain",
                              }}
                              className="rounded-xl"
                            />
                          ) : (
                            values.primary_image && (
                              <ImagePreview
                                file={values.primary_image}
                                id="primary_image"
                              />
                            )
                          )}
                        </label>
                        <ErrorMessage
                          name="primary_image"
                          component="div"
                          className="error mt-2 text-center"
                        />
                      </div>
                    </div>

                    {/* sub category  */}
                    <FormField
                      label="Sub Category"
                      tooltip="Select type of Sub Category"
                    >
                      {/* {JSON.stringify(values?.sub_category)} */}
                      <div id="sub_category">
                        <Dropdown
                          options={subCategory?.length > 0 ? subCategory : [{}]}
                          name="sub_category"
                          value={values?.sub_category}
                          onChange={handleChange}
                          handleOnchange={(v) => {
                            console.log("subcategory", v);
                            setCategoryId(v?.category?._id);
                            getDeliveryTypeById(
                              v?.category?.delivery_calculation,
                            );
                          }}
                        />
                        <ErrorMessage
                          name="sub_category"
                          component="div"
                          className="error"
                        />
                      </div>
                    </FormField>
                    {/* Origin (Country) */}
                    <FormField
                      label="Origin"
                      tooltip="Select country of origin"
                    >
                      <div id="origin">
                        <Dropdown
                          options={countryOptions}
                          name="origin"
                          value={values.origin}
                          onChange={handleChange}
                        />
                      </div>
                      <ErrorMessage
                        name="origin"
                        component="div"
                        className="error"
                      />
                    </FormField>

                    {/* item name  */}
                    <FormField label="Item Name" tooltip="Enter product name">
                      <div className="flex items-center" id="item_name">
                        <span className="border p-2 pl-3 pr-5 text-sm border-r-none">
                          EN
                        </span>
                        <TextInput
                          name="name"
                          type="text"
                          placeholder="Item Name"
                          value={values.name}
                          onChange={handleChange}
                          required={true}
                        />
                      </div>
                      <ErrorMessage
                        name="name"
                        component="div"
                        className="error"
                      />
                    </FormField>
                    {/* tax  */}
                    <FormField
                      label="TAX"
                      className="w-[100%]"
                      tooltip="Select type of Tex"
                    >
                      {/* {JSON.stringify(values.tax)}             */}
                      <div id="tax">
                        <Dropdown
                          options={taxOptions ? taxOptions : [{}]}
                          name="tax"
                          value={values.tax}
                          onChange={handleChange}
                          handleOnchange={(v) => {
                            console.log(v);
                            const d = v.taxes.sort((a, b) =>
                              a.taxType.localeCompare(b.taxType),
                            );
                            console.log(d);
                            setTaxes(d);
                          }}
                        />
                      </div>
                      <ErrorMessage
                        name="tax"
                        component="div"
                        className="error"
                      />
                    </FormField>
                    {/* mrp_price  */}
                    <FormField
                      label="MRP Price"
                      tooltip="Enter MRP Price of crop"
                    >
                      <div className="flex items-center" id="mrp_price">
                        <TextInput
                          name="mrp_price"
                          type="text"
                          placeholder="enter MRP Price"
                          value={values.mrp_price}
                          onChange={(e) => {
                            const newValue = e.target.value; // Get input value
                            setFieldValue("mrp_price", newValue); // Update Formik state

                            // Prepare product details
                            const product_details = [
                              { mrp_price: newValue },
                              { sales_price: values.sales_price },
                            ];
                            TaxCalculation(product_details);
                          }}
                        />
                      </div>
                      <ErrorMessage
                        name="mrp_price"
                        component="div"
                        className="error"
                      />
                    </FormField>

                    {/* sales  */}
                    <FormField
                      label="Sales Price"
                      tooltip="Enter Sales Price of crop"
                    >
                      <div className="flex items-center" id="sales_price">
                        <TextInput
                          name="sales_price"
                          type="text"
                          placeholder="enter Sales Price"
                          value={values.sales_price}
                          onChange={(e) => {
                            const newValue = e.target.value; // Get input value
                            setFieldValue("sales_price", newValue); // Update Formik state

                            // Prepare product details
                            const product_details = [
                              { mrp_price: values.mrp_price },
                              { sales_price: newValue }, // Use updated value
                            ];
                            TaxCalculation(product_details);
                          }}
                        />
                      </div>

                      <ErrorMessage
                        name="sales_price"
                        component="div"
                        className="error"
                      />
                      {/* <Divider className="border border-gray300" /> */}
                      <div>
                        <h1>Tax Details</h1>
                        {/* {JSON.stringify(productDetailsWithTax)} */}
                        <TaxData data={productDetailsWithTax} />
                      </div>
                    </FormField>

                    {/* stock  */}
                    <FormField
                      label="Available Quantity"
                      tooltip="Enter Available Quantity of crop"
                    >
                      <div className="flex items-center" id="stock">
                        <TextInput
                          name="stock"
                          type="number"
                          placeholder="available quantity"
                          value={values.stock}
                          onChange={handleChange}
                          required={true}
                        />
                      </div>
                      <ErrorMessage
                        name="stock"
                        component="div"
                        className="error"
                      />
                    </FormField>

                    {/* Price Per Unit  */}
                    <FormField
                      label="Unit"
                      tooltip="Select type of Price Per Unit"
                    >
                      {/* {JSON.stringify(values?.sub_category)} */}
                      <div id="price_per_unit">
                        <div className="flex">
                          {/* <TextInput
                            name="price_per_unit"
                            type="text"
                            placeholder="enter value of price per unit"
                            value={values.price_per_unit}
                            onChange={handleChange}
                            required={true}
                          /> */}
                          <div id="unit" className="w-full">
                            <Dropdown
                              options={unitMasterData || []}
                              name="unit"
                              value={values?.unit}
                              onChange={handleChange}
                            />
                          </div>
                        </div>
                        <ErrorMessage
                          name="unit"
                          component="div"
                          className="error"
                        />
                      </div>
                    </FormField>

                    {/* Quality Grade  */}
                    <FormField
                      label="Quality Grade"
                      tooltip="Choose Grade of crop"
                    >
                      <Dropdown
                        options={[
                          {
                            label: "grade 1",
                            value: "grade1",
                          },
                          {
                            label: "grade 2",
                            value: "grade2",
                          },
                          {
                            label: "grade 3",
                            value: "grade3",
                          },
                          {
                            label: "grade 4",
                            value: "grade4",
                          },
                        ]}
                        name="quality_grade"
                        value={values.quality_grade}
                        onChange={handleChange}
                      />
                      <ErrorMessage
                        name="quality_grade"
                        component="div"
                        className="error"
                      />
                    </FormField>

                    {/* Package Type  */}
                    <FormField
                      label="Package Type"
                      tooltip="Choose Package Type from dropdown"
                    >
                      <div id="package_type">
                        <Dropdown
                          options={packageData || []}
                          name="package_type"
                          value={values.package_type}
                          onChange={handleChange}
                        />
                      </div>
                      <ErrorMessage
                        name="package_type"
                        component="div"
                        className="error"
                      />
                    </FormField>

                    {/* Harvest Date  */}
                    <FormField
                      label="Harvest Date"
                      tooltip="Enter Harvest Date of crop"
                    >
                      <div id="harvest_date">
                        <Calendar
                          placeholder="Select Harvest Date"
                          className="w-full h-10 border border-[#cdcfd1]"
                          value={values.harvest_date}
                          onChange={(v) => {
                            setFieldValue("harvest_date", v.value);
                            console.log("harvest date:", v.value);
                          }}
                        />
                      </div>
                      <ErrorMessage
                        name="harvest_date"
                        component="div"
                        className="error"
                      />
                    </FormField>

                    {/* dynamic fields  */}
                    {/* {JSON.stringify(dynamicFields)} */}
                    {dynamicFields.length > 0 ? (
                      <FormPreview
                        values={values.dynamicFields}
                        fieldName={"dynamicFields"}
                        dynamicFields={dynamicFields}
                        handleFieldChange={(v) => {
                          console.log("Dynamic Field Values", v);
                        }}
                      />
                    ) : (
                      ""
                    )}

                    {/* description  */}

                    <FormField
                      label="Description"
                      tooltip="write a brief description of item"
                    >
                      <div id="description">
                        <ReactQuill
                          theme="snow"
                          value={values.description}
                          onChange={(v) => setFieldValue("description", v)}
                        />
                        <ErrorMessage
                          name="description"
                          component="div"
                          className="error"
                        />
                      </div>

                      {/* <div>
              <small style={{ color: values?.description?.length > 120 ? "red" : "black" }}>
                {values?.description?.length}/120 characters
              </small>
            </div> */}
                    </FormField>

                    {/* Additional Information  */}
                    <FormField
                      label="Additional Information"
                      tooltip="write a brief additional information of item"
                    >
                      <div id="additional_info">
                        <ReactQuill
                          theme="snow"
                          value={values.additional_info}
                          onChange={(v) => setFieldValue("additional_info", v)}
                        />
                        <ErrorMessage
                          name="additional_info"
                          component="div"
                          className="error"
                        />
                      </div>
                    </FormField>

                    {/* Processing */}
                    <FormField
                      label="Processing"
                      tooltip="Describe processing details"
                    >
                      <div id="processing">
                        <ReactQuill
                          theme="snow"
                          value={values.processing}
                          onChange={(v) => setFieldValue("processing", v)}
                        />
                        <ErrorMessage
                          name="processing"
                          component="div"
                          className="error"
                        />
                      </div>
                    </FormField>

                    {/* Certification */}
                    <FormField
                      label="Certification"
                      tooltip="Describe certification details"
                    >
                      <div id="certification">
                        <ReactQuill
                          theme="snow"
                          value={values.certification}
                          onChange={(v) => setFieldValue("certification", v)}
                        />
                        <ErrorMessage
                          name="certification"
                          component="div"
                          className="error"
                        />
                      </div>
                    </FormField>

                    {/* Packaging */}
                    <FormField
                      label="Packaging"
                      tooltip="Describe packaging details"
                    >
                      <div id="packaging">
                        <ReactQuill
                          theme="snow"
                          value={values.packaging}
                          onChange={(v) => setFieldValue("packaging", v)}
                        />
                        <ErrorMessage
                          name="packaging"
                          component="div"
                          className="error"
                        />
                      </div>
                    </FormField>

                    {/* Specifications  */}
                    <FormField
                      label="Specifications"
                      tooltip="write a brief Specifications of item"
                    >
                      <div id="specification">
                        <ReactQuill
                          theme="snow"
                          value={values.specification}
                          onChange={(v) => setFieldValue("specification", v)}
                        />
                        <ErrorMessage
                          name="specification"
                          component="div"
                          className="error"
                        />
                      </div>
                    </FormField>

                    {/* Cancellation policy  */}
                    <FormField
                      label="Cancellation policy"
                      tooltip="write a brief Cancellation policy of item"
                    >
                      <div id="cancellation_policy">
                        <ReactQuill
                          theme="snow"
                          value={values.cancellation_policy}
                          onChange={(v) =>
                            setFieldValue("cancellation_policy", v)
                          }
                        />
                        <ErrorMessage
                          name="cancellation_policy"
                          component="div"
                          className="error"
                        />
                      </div>
                    </FormField>

                    {/* Replacement policy  */}
                    <FormField
                      label="Replacement policy"
                      tooltip="write a brief replacement policy of item"
                    >
                      <div id="replacement_policy">
                        <ReactQuill
                          theme="snow"
                          value={values.replacement_policy}
                          onChange={(v) =>
                            setFieldValue("replacement_policy", v)
                          }
                        />
                        <ErrorMessage
                          name="replacement_policy"
                          component="div"
                          className="error"
                        />
                      </div>
                    </FormField>

                    {/* Return policy  */}
                    <FormField
                      label="Return policy"
                      tooltip="write a brief return policy of item"
                    >
                      <div id="return_policy">
                        <ReactQuill
                          theme="snow"
                          value={values.return_policy}
                          onChange={(v) => setFieldValue("return_policy", v)}
                        />
                        <ErrorMessage
                          name="return_policy"
                          component="div"
                          className="error"
                        />
                      </div>
                    </FormField>

                    <FormField
                      label="Policy Validity Days"
                      tooltip="Enter Policy Validity Days"
                    >
                      <TextInput
                        name="Policy_Validity_Days"
                        type="number"
                        placeholder="Item Policy Validity Days"
                        value={values.Policy_Validity_Days}
                        onChange={handleChange}
                      />
                      <ErrorMessage
                        name="Policy_Validity_Days"
                        component="div"
                        className="error"
                      />
                    </FormField>

                    <div className="flex justify-between flex-wrap-reverse gap-4">
                      {/* is_visible  */}

                      <div id="is_visible">
                        <ToggleField
                          text="Is Item Visible to user?"
                          name="is_visible"
                          value={values.is_visible}
                        />
                        <ErrorMessage
                          name="is_visible"
                          component="div"
                          className="error"
                        />
                      </div>
                      {/* Sequence Number  */}
                      {/* <FormField
                        label="Sequence Number"
                        tooltip="Enter sequence Number"
                      >
                        <div id="sequence">
                          <TextInput
                            name="sequence"
                            type="number"
                            value={values.sequence}
                            onChange={handleChange}
                          />
                        </div>
                        <ErrorMessage
                          name="sequence"
                          component="div"
                          className="error"
                        />
                      </FormField> */}
                    </div>
                  </>
                )}
                {step === 2 && (
                  <div className="flex justify-center  gap-5 flex-wrap">
                    {imagesList.length > 0 &&
                      imagesList.map((imgUrl, index) => (
                        <div
                          key={index}
                          className="w-52 h-52 pb-3   shadow-2xl border  text-center rounded-xl relative"
                          onMouseEnter={() =>
                            (document.getElementById(
                              `deleteProductIcon-${index}`,
                            ).style.display = "inline-block")
                          }
                          onMouseLeave={() =>
                            (document.getElementById(
                              `deleteProductIcon-${index}`,
                            ).style.display = "none")
                          }
                        >
                          {/* <input
                       
                       type="checkbox"
                       className="m-2 absolute z-1 right-0"
                       value={index}
                       onChange={(e) => {
                        }}
                        /> */}
                          <i
                            id={`deleteProductIcon-${index}`}
                            style={{ display: "none" }}
                            className="absolute text-red700 z-10 top-0 right-0  bg-black rounded-full p-1 "
                          >
                            <MdDeleteOutline
                              onClick={() =>
                                openDeleteModal("product_images", imgUrl)
                              }
                              className="cursor-pointer  text-3xl"
                            />
                          </i>
                          <label htmlFor={`${imgUrl._id}`}>
                            <input
                              type="file"
                              id={`${imgUrl._id}`}
                              accept="image/*"
                              name="images"
                              onChange={(e) =>
                                handleAddMultipleImages(e, imgUrl._id)
                              }
                              style={{ display: "none" }}
                            />
                            <LazyLoadImage
                              src={imgUrl.image}
                              alt={`Item ${index + 1}`}
                              // style={{width:"5rem !important",height:"5rem !important", objectFit:"contain"}}
                              className="rounded-xl cursor-pointer"
                              loading="lazy"
                              effect="blur"
                            />
                          </label>
                        </div>
                      ))}
                    <label
                      htmlFor="image-upload"
                      className="w-52 h-44 shadow-2xl text-center rounded-xl flex items-center justify-center gap-3 flex-col cursor-pointer"
                    >
                      <IoAddCircleOutline className="text-5xl text-slate-500" />

                      <input
                        type="file"
                        id="image-upload"
                        accept="image/*"
                        multiple
                        name="images"
                        onChange={handleAddMultipleImages}
                        style={{ display: "none" }}
                      />
                      <span>Add Images</span>
                    </label>
                  </div>
                )}
                {/* <Variant
                  dynamicFields={dynamicFields}
                  taxDetails={Taxes}
                  editProduct={editProduct}
                  DeliveryTypes={deliveryType}
                  isOpen={isVariant}
                  editVariantData={editVariantData}
                  handleVariantClose={closeVariantModal}
                  handleSubmitVariant={handleSubmitVariant}
                /> */}
                {/* {step === 3 && allVariantData && allVariantData.length
                  ? allVariantData.map((p, i) => (
                      <div
                        key={p._id}
                        className="w-full h-fit p-3 shadow-2xl rounded-lg flex flex-col gap-4"
                      >
                        <div className="flex justify-between items-center">
                          <div className="flex gap-1.5 items-center ">
                            <FaRegCheckCircle className="text-lg text-hoverColor" />
                            <span className="text-[17px]">
                              {i + 1}. {p?.name}
                            </span>
                          </div>
                          <div className="flex gap-2">
                            <SecondaryButton
                              onClick={() => {
                                setEditVariantData(p);
                              }}
                              text="Edit"
                            />
                            <span
                              onClick={() => openDeleteModal("variant", p)}
                              className="border cursor-pointer border-errorColor hover:bg-red700 hover:text-white rounded-full  font-bold px-3 text-[12px]"
                            >
                              Delete
                            </span>
                          </div>
                        </div>
                      </div>
                    ))
                  : ""} */}
                {step === 1 && nutritionalFields?.length > 0 ? (
                  <FormPreview
                    values={values.nutritionalFields}
                    dynamicFields={nutritionalFields}
                    fieldName={"nutritionalFields"}
                    handleFieldChange={(v) => {
                      console.log("Nutritional Field Values", v);
                    }}
                  />
                ) : (
                  ""
                )}
              </Form>
            </SidebarField>
          )}
        </Formik>
      )}

      {editVisible && (
        <SubCategoryForm
          handleSubmit={handleSubmit}
          handleClose={() => handleClose()}
          initialValues={{
            name: editData.name || "",
            sequence: editData.sequence || "",
            category: editData.category || "",
            is_visible: editData.is_visible || false,
            categoryType: "Ecommerce",
          }}
        />
      )}
      <DeleteFieldModal
        isOpen={deleteModal}
        onClose={handleDeleteClose}
        onDelete={() => handleDelete()}
      />
      <ProductCalculations
        open={Boolean(calculationError)}
        data={calculationError}
      />
    </>
  );
};

export const SubCategoryForm = ({
  initialValues,
  handleSubmit,
  handleClose,
}) => {
  const [categoriesOptions, setCategoriesOptions] = useState([]);
  const { handleLoading } = useContext(LoaderContext);

  const fetchingCategoryItems = async () => {
    handleLoading(true);
    try {
      const res = await CategoryApi.getAllCategory();

      setCategoriesOptions(res.data?.data);
    } catch (err) {
      //console.log(err);
    } finally {
      handleLoading(false);
    }
  };

  const categoryOptions = categoriesOptions.map((cat) => {
    return {
      value: cat._id,
      label: cat.name,
    };
  });

  useEffect(() => {
    fetchingCategoryItems();
  }, []);
  return (
    <Formik initialValues={initialValues} onSubmit={handleSubmit}>
      {({ handleChange, values }) => (
        <Form>
          <SidebarField
            button1={
              <Button text="Cancel" type="button" onClick={handleClose} />
            }
            button2={<Button text="Submit" type="submit" />}
            handleClose={handleClose}
            title={values.name ? "Edit Sub Category" : "Add New Sub Category"}
          >
            <div className="w-full gap-4 flex flex-col bg-transparent py-5 px-3">
              <FormField label="Sub Category Name" tooltip="Enter subcategory">
                <TextInput
                  name="name"
                  type="text"
                  placeholder="Sub Category Name"
                  onChange={handleChange}
                  required={true}
                  value={values.name}
                />
                <ErrorMessage name="name" component="div" className="error" />
              </FormField>

              <FormField label="Category" tooltip="Choose or create a category">
                <div className="flex items-center gap-2">
                  <Dropdown
                    options={categoryOptions}
                    name="category"
                    value={values.category}
                    placeholder="Choose your category"
                  />
                </div>
                <ErrorMessage
                  name="category"
                  component="div"
                  className="error"
                />
              </FormField>

              <FormField
                label="Sequence Number"
                tooltip="Enter sequence number to sort the subcategory"
              >
                <TextInput
                  name="sequence"
                  type="number"
                  placeholder="Sequence Number"
                  onChange={handleChange}
                  required={true}
                  value={values.sequence}
                />
                <ErrorMessage name="number" component="div" className="error" />
              </FormField>
              <ToggleField
                text="Is subcategory visible to user?"
                name="is_visible"
                onChange={handleChange}
                value={values.is_visible}
              />
            </div>
          </SidebarField>
        </Form>
      )}
    </Formik>
  );
};

export default ItemListCashcrop;

const ProductCalculations = ({ open, close, heading, message, data }) => {
  // console.log("data:",data);

  const [modal, setModal] = useState(false);
  const handleClose = () => {
    setModal(false);
    close && close();
  };
  // useEffect(()=>{
  //   setModal(true)
  // },[data])
  if (modal) {
    return (
      <SidebarField
        footer={false}
        button1={
          <Button text="Cancel" type="button" onClick={() => handleClose()} />
        }
        button2={<Button text="Submit" type="submit" />}
        handleClose={() => handleClose()}
        title={heading ? heading : "Price Calculation Of Product"}
      >
        <TaxData
          key={data?.name}
          item={data}
          message={message || "MRP price must be less than Grand Total!"}
        />
      </SidebarField>
    );
  }
};
